export const colorKind = {
  red: [
    '#FFFFCC',
    '#CCFFFF',
    '#FFCCCC',
    '#99CCCC',
    '#FFCC99',
    '#FFCCCC',
    '#FF9999',
    '#996699',
    '#FFCCCC',
    '#CC9999',
    '#FFFFCC',
    '#CCCC99',
    '#FFCCCC',
    '#FFFF99',
    '#CCCCFF',
    '#0099CC',
    '#CCCCCC',
    '#FF6666',
    '#FF9966',
    '#FF6666',
    '#FFCCCC',
    '#CC9966',
    '#666666',
    '#CC9999',
    '#FF6666',
    '#FFFF66',
    '#99CC66',
    '#CC3333',
    '#CCCCCC',
    '#003366',
    '#993333',
    '#CCCC00',
    '#663366',
    '#CCCC99',
    '#666666',
    '#CC9999',
    '#FF6666',
    '#FFFF00',
    '#0066CC',
    '#CC0033',
    '#333333',
    '#CCCC00',
    '#336633',
    '#990033',
    '#FFCC99',
    '#993333',
    '#CC9966',
    '#003300',
    '#FF0033',
    '#333399',
    '#CCCC00',
    '#CC0033',
    '#000000',
    '#003399',
    '#000000',
    '#99CC00',
    '#CC0033',
    '#999933',
    '#993333',
    '#333300'
  ] as string[],
  orange: [
    '#FFCC99',
    '#FFFF99',
    '#99CC99',
    '#FFCC99',
    '#CCFF99',
    '#CCCCCC',
    '#FFCC99',
    '#FFFFCC',
    '#99CCFF',
    '#FF9966',
    '#FFFFCC',
    '#99CC99',
    '#FF9900',
    '#FFFFCC',
    '#336699',
    '#CCCC33',
    '#FFFF99',
    '#CC9933',
    '#996600',
    '#FFCC33',
    '#FFFFCC',
    '#FFFFCC',
    '#CC9933',
    '#336666',
    '#FF9900',
    '#FFFF00',
    '#0099CC',
    '#99CC33',
    '#FF9900',
    '#FFCC00',
    '#FF9933',
    '#99CC33',
    '#CC6699',
    '#FF9933',
    '#FFFF00',
    '#3366CC',
    '#FF9933',
    '#FFFFCC',
    '#009966',
    '#FF6600',
    '#FFFF66',
    '#009966',
    '#990033',
    '#CCFF66',
    '#FF9900',
    '#FF9966',
    '#996600',
    '#CCCC00',
    '#CC6600',
    '#999999',
    '#CCCC33',
    '#CC6600',
    '#CCCC33',
    '#336699',
    '#000000',
    '#FF9933',
    '#999966',
    '#663300',
    '#FF9933',
    '#FFFF66'
  ] as string[],
  yellow: [
    '#FFFFCC',
    '#CCFFFF',
    '#FFCCCC',
    '#FFFF00',
    '#FFFFFF',
    '#CCCC00',
    '#99CCFF',
    '#FFCC33',
    '#FFFFCC',
    '#FFFF33',
    '#99CCFF',
    '#CCCCCC',
    '#FFFF00',
    '#FFFFFF',
    '#9933FF',
    '#99CCFF',
    '#FFCC33',
    '#FFFF33',
    '#FFCC00',
    '#66CC00',
    '#FFFF99',
    '#FF9900',
    '#FFFF00',
    '#0099CC',
    '#FFCC00',
    '#0000CC',
    '#FFFF99',
    '#CC9999',
    '#FFFFCC',
    '#6666CC',
    '#999933',
    '#FFFFCC',
    '#CC99CC',
    '#CCCC00',
    '#666600',
    '#FFFF66',
    '#FF9966',
    '#FFFFCC',
    '#99CC99',
    '#FFCC33',
    '#FFFFCC',
    '#999966',
    '#FFCC99',
    '#FF6666',
    '#FFFF66',
    '#FFCC99',
    '#999966',
    '#FFFF00',
    '#FFFF99',
    '#99CC99',
    '#666600',
    '#999966',
    '#FFFF99',
    '#333333',
    '#006633',
    '#333300',
    '#CCCC99',
    '#006633',
    '#663300',
    '#CCCC66'
  ] as string[],
  Yellow_green: [
    '#33CC33',
    '#6666CC',
    '#FFFFFF',
    '#CCCC33',
    '#FFFFFF',
    '#CCFFCC',
    '#FFCC99',
    '#CCFF99',
    '#CCCCCC',
    '#CCCC00',
    '#999966',
    '#FFFFCC',
    '#CCCC33',
    '#FFFFFF',
    '#336699',
    '#CCCC33',
    '#999999',
    '#CCFFFF',
    '#00CC00',
    '#0066CC',
    '#99CCCC',
    '#99CC33',
    '#FF9900',
    '#FFCC00',
    '#99CC33',
    '#CCCCFF',
    '#663300',
    '#CCCC33',
    '#993399',
    '#000000',
    '#CC6600',
    '#999999',
    '#CCCC33',
    '#CC9933',
    '#FFFF99',
    '#99CC99',
    '#669933',
    '#CCCC33',
    '#663300',
    '#99CC33',
    '#CCCCCC',
    '#000000',
    '#CC6600',
    '#CCCC33',
    '#336699',
    '#666600',
    '#CCCC66',
    '#CCFFCC',
    '#333366',
    '#99CC33',
    '#336699',
    '#666666',
    '#99CC33',
    '#003366',
    '#003333',
    '#99CC33',
    '#999999',
    '#996633',
    '#FFFF99',
    '#99CC66'
  ] as string[],
  green: [
    '#009966',
    '#FFFFFF',
    '#FFFF00',
    '#339933',
    '#FFFFFF',
    '#9933CC',
    '#339933',
    '#FFFFFF',
    '#000000',
    '#339933',
    '#99CC00',
    '#FFFFCC',
    '#FFFFCC',
    '#CCCC66',
    '#336666',
    '#99CC33',
    '#FFFF66',
    '#336600',
    '#339933',
    '#CC9900',
    '#666666',
    '#339966',
    '#CCCCCC',
    '#003366',
    '#669933',
    '#CCCCCC',
    '#000000',
    '#339933',
    '#CCCCCC',
    '#6699CC',
    '#006633',
    '#CCCC33',
    '#CC9933',
    '#339933',
    '#666633',
    '#CCCC66',
    '#339933',
    '#FFCC33',
    '#336699',
    '#006633',
    '#669933',
    '#99CC99',
    '#336666',
    '#996633',
    '#CCCC33',
    '#003300',
    '#669933',
    '#CCCC99',
    '#006633',
    '#990033',
    '#FF9900',
    '#006633',
    '#333300',
    '#CCCC99',
    '#006633',
    '#663300',
    '#CCCC66',
    '#993333',
    '#CC9966',
    '#003300'
  ] as string[],
  turquoise: [
    '#CCFF99',
    '#FFFFFF',
    '#66CCCC',
    '#339999',
    '#FFFFFF',
    '#99CCFF',
    '#66CC99',
    '#FFFFFF',
    '#666699',
    '#009999',
    '#66CCCC',
    '#CCFFFF',
    '#66CCCC',
    '#CCFF66',
    '#FF99CC',
    '#339999',
    '#FFFF00',
    '#336699',
    '#CC9933',
    '#339999',
    '#FFCC33',
    '#FFCC00',
    '#009999',
    '#CC3333',
    '#669999',
    '#CCCCCC',
    '#CC99CC',
    '#339999',
    '#CCCCCC',
    '#000000',
    '#339999',
    '#666699',
    '#CCCCCC',
    '#003333',
    '#99CC99',
    '#FFFFCC',
    '#669999',
    '#CCFFCC',
    '#996699',
    '#996699',
    '#CCCC99',
    '#669999',
    '#999966',
    '#CCCC99',
    '#339999',
    '#336666',
    '#669999',
    '#CCCC99',
    '#999999',
    '#003366',
    '#669999',
    '#663333',
    '#339999',
    '#CCCC66',
    '#333333',
    '#339999',
    '#CCFFCC',
    '#336666',
    '#3399CC',
    '#666666'
  ] as string[],
  blue: [
    '#FFFFCC',
    '#CCFFFF',
    '#FFCCCC',
    '#99CCCC',
    '#FFFFFF',
    '#3399CC',
    '#CCFFCC',
    '#99CCCC',
    '#FFFFCC',
    '#CCCCFF',
    '#FFFFFF',
    '#99CCFF',
    '#FFCC99',
    '#FFFFCC',
    '#99CCFF',
    '#336699',
    '#FFFFFF',
    '#99CCCC',
    '#99CCCC',
    '#FFFFFF',
    '#CCFF99',
    '#CCCCFF',
    '#FFFFCC',
    '#CCFFFF',
    '#99CCCC',
    '#FFFFFF',
    '#336699',
    '#99CCFF',
    '#CCFFFF',
    '#6699CC',
    '#99CC33',
    '#FFFFFF',
    '#3399CC',
    '#0099CC',
    '#FFFFCC',
    '#666699',
    '#CCCCCC',
    '#003366',
    '#99CCFF',
    '#0099CC',
    '#FFFFFF',
    '#666666',
    '#CCCCCC',
    '#6699CC',
    '#666666',
    '#336699',
    '#CCCC99',
    '#003366',
    '#3399CC',
    '#003366',
    '#CCCCCC',
    '#6699CC',
    '#006699',
    '#000000',
    '#003366',
    '#CCCCCC',
    '#006699',
    '#999933',
    '#336699',
    '#333333'
  ] as string[],
  Blue_purple: [
    '#CCFFFF',
    '#FFFFFF',
    '#CCCCFF',
    '#CCCCCC',
    '#FFFFFF',
    '#666699',
    '#99CCFF',
    '#FFFFFF',
    '#333399',
    '#6666CC',
    '#FFFFFF',
    '#FF9999',
    '#9999FF',
    '#FFCC33',
    '#FFFFCC',
    '#0099CC',
    '#FFFFCC',
    '#666699',
    '#0000FF',
    '#6699FF',
    '#CCFFFF',
    '#6666FF',
    '#66CCFF',
    '#CCFF66',
    '#669999',
    '#FFFFCC',
    '#6666CC',
    '#9999CC',
    '#FF9999',
    '#666699',
    '#003399',
    '#FFCCCC',
    '#6699CC',
    '#CC6666',
    '#333399',
    '#CCCC00',
    '#000066',
    '#6666FF',
    '#CCCCCC',
    '#003399',
    '#CCFF99',
    '#333333',
    '#333366',
    '#CC0033',
    '#CCCCCC',
    '#336699',
    '#CCCC66',
    '#333300',
    '#003399',
    '#FFFF99',
    '#000000',
    '#990066',
    '#CCCC33',
    '#003399',
    '#CC3333',
    '#000000',
    '#003399',
    '#333366',
    '#999966',
    '#333333'
  ] as string[],
  purple: [
    '#FFFFCC',
    '#FFFF99',
    '#CCCCFF',
    '#9999CC',
    '#99CC99',
    '#FFFFFF',
    '#FFCCCC',
    '#CCCCFF',
    '#CCCC99',
    '#9999CC',
    '#FFFFCC',
    '#FFCCCC',
    '#FFCCCC',
    '#FF99CC',
    '#CCCCFF',
    '#660066',
    '#FFFFFF',
    '#663333',
    '#CCCC99',
    '#333333',
    '#9966CC',
    '#CCCC00',
    '#FF9966',
    '#663399',
    '#996699',
    '#FFCCCC',
    '#CC99CC',
    '#996666',
    '#CC99CC',
    '#FFCCCC',
    '#FFCC99',
    '#FF9933',
    '#663366',
    '#333399',
    '#CCCCFF',
    '#CC99CC',
    '#663366',
    '#CCCCCC',
    '#CC99CC',
    '#996699',
    '#9999CC',
    '#CCCCFF',
    '#CC9966',
    '#999999',
    '#663366',
    '#330033',
    '#666666',
    '#669999',
    '#CCCCCC',
    '#999999',
    '#663366',
    '#FF33CC',
    '#CCCC99',
    '#663366',
    '#663366',
    '#999999',
    '#CCCCFF',
    '#999966',
    '#993333',
    '#330033'
  ] as string[],
  amaranth: [
    '#FFCCCC',
    '#FFFFFF',
    '#99CC00',
    '#FF99CC',
    '#FFFFFF',
    '#993366',
    '#66CC99',
    '#FFFFFF',
    '#CC6699',
    '#CC9999',
    '#FFCCCC',
    '#CC99CC',
    '#FFCCCC',
    '#FFFF99',
    '#CCCCFF',
    '#FFFF99',
    '#993399',
    '#FF99CC',
    '#66CCCC',
    '#CCFF66',
    '#FF99CC',
    '#FF99CC',
    '#003399',
    '#CCCC00',
    '#FFCCCC',
    '#FF99CC',
    '#CCCCFF',
    '#FF9999',
    '#FFCCCC',
    '#FF99CC',
    '#669966',
    '#CC6699',
    '#FFCCFF',
    '#CCCCCC',
    '#CC99CC',
    '#CC3399',
    '#CC3399',
    '#FFCC99',
    '#FF6666',
    '#FF3399',
    '#CCCC99',
    '#663366',
    '#663366',
    '#FFFFCC',
    '#FFCCCC',
    '#663366',
    '#CCCCCC',
    '#CC99CC',
    '#990066',
    '#FFCC00',
    '#CC0033',
    '#990066',
    '#CCCCCC',
    '#006699',
    '#999900',
    '#990033',
    '#000000',
    '#990066',
    '#000000',
    '#009966'
  ] as string[]
};
